var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.207 1.575A.5.5 0 01.587.75h6.826a.5.5 0 01.38.825L4.38 5.557a.5.5 0 01-.76 0L.207 1.575z",
    fill: "#4C6AFF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC4yMDc0ODIgMS41NzUzOUMtMC4wNzA1MjA0IDEuMjUxMDYgMC4xNTk5MzQgMC43NDk5OTkgMC41ODcxMTEgMC43NDk5OTlMNy40MTI4OSAwLjc1QzcuODQwMDcgMC43NSA4LjA3MDUyIDEuMjUxMDYgNy43OTI1MiAxLjU3NTRMNC4zNzk2MyA1LjU1NzFDNC4xODAwOCA1Ljc4OTkxIDMuODE5OTIgNS43ODk5MSAzLjYyMDM3IDUuNTU3MUwwLjIwNzQ4MiAxLjU3NTM5WiIgZmlsbD0iIzRDNkFGRiIvPgo8L3N2Zz4K";
export { SvgFilterTriangleDown as ReactComponent };